/*
 * COPYRIGHT Motorola Solutions, INC.
 * ALL RIGHTS RESERVED.
 * MOTOROLA SOLUTIONS CONFIDENTIAL RESTRICTED
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { deleteTddMessage, fetchPredefinedTddMessages, initializeTddMessageState, newTddMessage, updateTddMessage } from '../+state/message.actions';
import { Message } from 'CalltakingCoreApi';
import { MessageService } from './message.service';
import { ClusterUrlProviderService } from '../../core/services/cluster-url-provider.service';
import { Topic } from '../../user/model/multiple-subscriptions';
import { StompManagerService } from '../../core/services/stomp-manager/stomp-manager.service';

@Injectable({
    providedIn: 'root'
})
export class TddMessageService extends MessageService {

    constructor(
        private http: HttpClient,
        protected store: Store,
        private clusterUrlProviderService: ClusterUrlProviderService,
        protected stompManager: StompManagerService
    ) {
        super('TDD', store, stompManager);
    }

    protected getTopics(): Topic[] {
        return [Topic.MESSAGES_TDD_NEW, Topic.MESSAGES_TDD_EDIT, Topic.MESSAGES_TDD_DELETE];
    }

    protected getTopicHandlers(): { [topic in Topic]?: (message: any) => void } {
        return {
            [Topic.MESSAGES_TDD_NEW]: this.newMessage.bind(this),
            [Topic.MESSAGES_TDD_EDIT]: this.editMessage.bind(this),
            [Topic.MESSAGES_TDD_DELETE]: this.deleteMessage.bind(this)
        };
    }

    protected effectsInitialized(): void {
        this.store.dispatch(fetchPredefinedTddMessages());
    }

    protected websocketInitialized(clusterName?: string ): void {
        this.store.dispatch(initializeTddMessageState({ clusterName: clusterName }));
    }

    protected deleteMessage(message: Message): void {
        this.store.dispatch(deleteTddMessage({ message }));
    }

    protected editMessage(message: Message): void {
        this.store.dispatch(updateTddMessage({ message }));
    }

    protected newMessage(message: Message): void {
        this.store.dispatch(newTddMessage({ message }));
    }

    public requestTddMessages(callId: string, clusterName: string) {
        const url = this.clusterUrlProviderService.getClusterSpecificUrl(clusterName, `${this.API_BASE_URL}${callId}/load/${this.type}`);
        return this.http.get<Message[]>(url, { observe: 'body', responseType: 'json' });
    }
}
